import { MARKER_PROPS } from '@ardoq/icons';

export const maximumMarkerWidth = Math.max(
  ...Object.values(MARKER_PROPS).map(({ markerWidth }) => markerWidth)
);
